import { normalizeValue } from '@/srcV2/utils';
import { DEFAULT_WEBSITE_HINT } from './constants';

export const PLACEHOLDER_ANIMATION_DELAY_MS = {
	delete: 25,
	pause: 2000,
	type: 50
} as const;

export const buildPlaceholderHints = (
	defaultWebsiteHint?: string,
	businessDescriptionHint?: string
) => {
	const hints = [
		normalizeValue(defaultWebsiteHint) ?? DEFAULT_WEBSITE_HINT,
		normalizeValue(businessDescriptionHint)
	]
		.map((value) => normalizeValue(value))
		.filter((value): value is string => Boolean(value));

	return hints;
};

export const entranceAnimation = (delay = 0) => ({
	animate: { opacity: 1, y: 0 },
	initial: { opacity: 0, y: 18 },
	transition: { delay, duration: 0.45, ease: 'easeOut' as const }
});
